type SectionHeadingProps = {
  en: string;
  jp?: string;
  align?: "left" | "center";
  lead?: string;
  note?: string;
  className?: string;
  enClassName?: string;
  light?: boolean;
};

export default function SectionHeading({
  en,
  jp,
  align = "left",
  lead,
  note,
  className = "",
  light = false,
}: SectionHeadingProps) {
  const alignClass = align === "center" ? "items-center text-center" : "items-start text-left";
  const enColor = light ? "text-background-200" : "text-secondary-700";
  const jpColor = light ? "text-background-50" : "text-foreground-950";
  const noteColor = light ? "text-background-200/80" : "text-foreground-600";

  return (
    <div className={`flex flex-col ${alignClass} ${className}`}>
      <span className={`en-eyebrow text-[10px] md:text-[11px] ${enColor}`}>{en}</span>
      <span className={`mt-5 block h-px w-10 ${light ? "bg-accent-400" : "bg-accent-500"}`} />
      {jp ? (
        <h2
          className={`mt-6 font-heading font-medium leading-[1.55] text-[26px] md:text-[38px] tracking-[0.02em] whitespace-pre-line ${jpColor}`}
        >
          {jp}
        </h2>
      ) : null}
      {lead ? (
        <p className={`mt-5 max-w-2xl text-sm md:text-[15px] leading-[2] ${noteColor} whitespace-pre-line`}>{lead}</p>
      ) : null}
      {note ? (
        <p
          className={`mt-4 max-w-2xl text-[13px] md:text-sm leading-[2] ${noteColor} whitespace-pre-line ${
            align === "center" ? "text-center" : ""
          }`}
        >
          {note}
        </p>
      ) : null}
    </div>
  );
}